import request from "@/config/utils/request";
import { loadingParams } from "@/basa/utils/public";

// 我的待办列表
export function queryProcessReminder(data) {
  return request({
    url: "/apis/ebs/reminder/queryProcessReminder",
    method: "post",
    data: { ...data, ...loadingParams }
  });
}
// 审批通过/审批退回点击时，将消息变更为已读
export function readProcessReminder(data) {
  return request({
    url: "/apis/ebs/reminder/readProcessReminder",
    method: "post",
    data: { ...data, ...loadingParams }
  });
}
